<!--pdf图片的展示，作图数据的下载-->
<template>
  <div style="display: flex; flex-direction: column ;width: 100%;--scale-factor: 1;" v-loading="loading"
       element-loading-text="图片加载中">
    <div v-if="pdf||img" style="height: 560px;width: 100%; ">
      <iframe :src="`static/pdf/web/viewer.html?file=${encodeURIComponent(src)}`"
              style="height: 100%;width: 100%;border: 0px;">
      </iframe>
      <!--      //下载地方-->
      <div style="display: flex;width: 100%;margin-top: 30px;justify-content: center">
        <div>
          <el-dropdown @command="downDrawData">
            <el-button style="margin-right: 60px;">下载作图数据<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="xls">下载xls格式</el-dropdown-item>
              <el-dropdown-item command="xlsx">下载xlsx格式</el-dropdown-item>
              <el-dropdown-item command="txt">下载txt格式</el-dropdown-item>
              <el-dropdown-item command="csv">下载csv格式</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button style="margin-right: 40px" @click="downloadResultPicture('pdf')">下载pdf</el-button>
        <el-button @click="downloadResultPicture('png')">下载png</el-button>
      </div>
    </div>
    <div v-if="html">
      <iframe
        :src="srcHtml+'#view=Fit'"
        width="100%"
        :height="iframeH"
        allowfullscreen="true"
        style="overflow: hidden"
        class="iframe"
        border="0"
      >
      </iframe>
    </div>

  </div>
</template>

<script>
import {downAsBlob} from "@/utils/download";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: "FilePdf",
  props: {
    analyzeId: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    folder: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: ""
    },
    types: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      viewName: '',
      src: '',
      pdf: false,
      img: false,
      html: false,
      folderLast: '',
      loading: true,
      srcHtml: '',
      iframeH: '600px',
      height: '',
      srcList: []

    }
  },
  created() {
    let that = this
    // this.getPdf()

  },
  mounted() {
    this.getPdf()
    // this.loadPDF()
  },
  methods: {
    downloadResultPicture(type) {
      let method='get'
      let url='/preview/downloadResultSet/' + this.projectId + "/" + this.analyzeId + "/" + type + "/" + this.folder
      downAsBlob(method,url )
      // const data = await this.$http({
      //   method: 'get',
      //   url: '/preview/downloadResultSet/' + this.projectId + "/" + this.analyzeId + "/" + type + "/" + this.folder,
      //   responseType: 'blob',
      // })
      // if (data) {
      //   fileDownload(data.file, data.fileName)
      //   this.$messageUi.success('下载成功')
      // } else {
      //   this.$messageUi('下载失败')
      // }
      // const url=`${baseURL}/preview/downloadResultSet/${this.projectId}/${this.analyzeId}/${type}/${this.folder}?token=${getDataInLocalStorage("token")}`
      // const elink = document.createElement('a')
      // elink.href = url
      // document.body.appendChild(elink)
      // elink.click()
    },
    downDrawData(type) {
      // const res = await this.$http({
      //   method: 'get',
      //   url: '/preview/imgRawData/' + this.projectId + '/' + this.analyzeId + '/' + type + '/' + this.folder,
      //   responseType: 'blob',
      // })
      // console.log(res)
      // if(res.file){
      //   fileDownload(res.file, res.fileName)
      //   this.$messageUi.success('下载成功')
      // }else {
      //   this.$http({
      //      method: 'get',
      //      url: '/preview/imgRawData/' + this.projectId + '/' + this.analyzeId + '/' + type + '/' + this.folder,
      //    }).then(res=>{
      //     this.$messageUi.error('下载失败,'+res.message)
      //   })
      // }
      let method='get'
      let url='/preview/imgRawData/' + this.projectId + '/' + this.analyzeId + '/' + type + '/' + this.folder
      downAsBlob(method,url )
      // const url=`${baseURL}/preview/imgRawData/${this.projectId}/${ this.analyzeId}/${type}/${this.folder}?token=${getDataInLocalStorage("token")}`
      // const elink = document.createElement('a')
      // elink.href = url
      // document.body.appendChild(elink)
      // elink.click()
      // this.$messageUi.success('下载成功')
    },
    async getPdf(path, again) {
      let folder = ''
      if (again !== 2) {
        folder = this.folder
      } else {
        folder = path
      }
      const result = await this.$http({
        method: 'get',
        url: '/preview/view/' + this.projectId + "/" + this.analyzeId + "/" + folder,
        responseType: 'blob',
      })

      var name = this.fileName.toString()
      if (name.endsWith('pdf')) {
        this.pdf = true
      } else if (name.endsWith('png')) {
        this.pdf = true
      } else {

      }
      var binaryData = [];
      binaryData.push(result);
      if (this.types === 'pdf') {
        let url = window.URL.createObjectURL(
          new Blob(binaryData, {
            type: "application/pdf;charset=utf-8",
          })
        );
        if (url !== null && url !== undefined && url) {
          this.src = url
          this.srcList.push(url)
          // this.handlePngSize()
        }
      } else {
        let url = window.URL.createObjectURL(
          new Blob(binaryData, {
            type: "text/html;charset=utf-8",
          })
        )
        if (url !== null && url !== undefined && url) {
          this.srcHtml = url
          this.html = true
        }
      }
      this.loading = false
      let that = this
    },
  },
}
</script>

<style scoped>
.iframe {
  display: block;
  vertical-align: middle
}
</style>
